var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12"},[_c('ul',{staticClass:"list-1"},_vm._l((_vm.list),function(item,i){return _c('li',{key:i},[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }